var path = '/client/front-office/modules/layout/modules/front/views/front-social-advocacy-public-template.html';
var html = "<div>\n  <react-element react-component=\"SAPublicTemplate\"  react-replace=\"true\" />\n</div>";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;